import React from 'react';
import { useHistory } from 'react-router-dom';

import { isIosApp, isIosWeb } from '../../../../utils/platform';
import AppleLogin from './AppleLogin';
import FacebookLogin from './FacebookLogin';
import GoogleLogin from './GoogleLogin';

const CSS = require('./AuthButtons.module.scss');

interface AuthButtonsProps {
  isLogin?: boolean;
  afterLogin?: () => any;
  companyName?: string;
  lastUsedProvider?: 'google' | 'facebook' | 'apple' | 'email';
}

function AuthButtons({
  isLogin,
  afterLogin,
  lastUsedProvider,
}: AuthButtonsProps) {
  const history = useHistory();
  const searchParams = new URLSearchParams(window.location.search);
  const returnTo = searchParams.get('returnTo') || '/';
  const onLoginResult =
    (setState: (any) => any) =>
    ({
      error,
      success,
      redirectUrl,
    }: {
      error?: any;
      success: boolean;
      redirectUrl?: string;
    }) => {
      if (!success) {
        console.error(`Login failed: ${error}`);
        setState({ error: `Login failed: ${error}`, loading: false });
        return;
      }

      setState({ error: null, loading: false });

      if (redirectUrl) {
        const startsWithSlash = redirectUrl.startsWith('/');
        if (startsWithSlash) {
          history.push(redirectUrl);
        } else {
          window.location.href = redirectUrl;
          return;
        }
      }
    };
  const AppleAuthButton = (
    <AppleLogin
      isLogin={isLogin}
      afterLogin={afterLogin}
      callbackUrl={returnTo}
      onLoginResult={onLoginResult}
      isLastUsed={lastUsedProvider === 'apple'}
    />
  );

  return (
    <div className={CSS.AuthButtons}>
      {(isIosApp() || isIosWeb()) && AppleAuthButton}
      <FacebookLogin
        isLogin={isLogin}
        afterLogin={afterLogin}
        callbackUrl={returnTo}
        onLoginResult={onLoginResult}
        isLastUsed={lastUsedProvider === 'facebook'}
      />
      {!isIosApp() && !isIosWeb() && AppleAuthButton}
      <GoogleLogin
        isLogin={isLogin}
        afterLogin={afterLogin}
        callbackUrl={returnTo}
        onLoginResult={onLoginResult}
        isLastUsed={lastUsedProvider === 'google'}
      />
    </div>
  );
}

export default AuthButtons;
